import { render, staticRenderFns } from "./Juridisch.vue?vue&type=template&id=08ee7d07&"
import script from "./Juridisch.vue?vue&type=script&lang=js&"
export * from "./Juridisch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports